import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";

/*
 * @Author       : Zhelin Cheng
 * @Date         : 2021-04-30 11:15:53
 * @LastEditors  : 程哲林
 * @LastEditTime : 2023-11-15 19:36:26
 * @FilePath     : /marketing-landing-fe/src/const/index.ts
 * @Description  : 未添加文件描述
 */
export function envPath(name) {
  if (name === void 0) {
    name = 'pro';
  }

  return name === 'pro' ? '' : ".".concat(name);
}
export function envFactory(key) {
  var _a, _b;

  return ((_b = (_a = window === null || window === void 0 ? void 0 : window.process) === null || _a === void 0 ? void 0 : _a.env) === null || _b === void 0 ? void 0 : _b[key]) || '';
} // 全局变量通过define-plugin注入

var envDebug = process.env.NODE_ENV === 'development'; // 本地调试

export var envName = envFactory('ENV_NAME'); // 环境变量

export var buildTime = envFactory('BUILD_TIME');
export var envCdnUrl = envFactory('CDN_DOMAIN');
export var MOCK = envFactory('MOCK');
export var tagName = envFactory('CI_TAG_NAME');
export var APP_NAME = envFactory('APP_NAME');
export var ENV_BASE = envFactory('ENV_BASE');
export var WX_APP_ID = envFactory('WX_APP_ID');
export var isJoJoUp = APP_NAME === 'jojoup';
export var addTeacherPath = isJoJoUp ? '/mall/market' : ''; // const env: any = window?.process?.env.ALL_ENV || {};

export var jojoEnvBase = '/act2/qwerup';
export var LOCAL_BASE_URL = isJoJoUp ? "".concat(window.location.origin).concat(ENV_BASE, "/qwerup") : "".concat(window.location.origin, "/act2/qwerup"); // 本地跳转的基础路径
// export const LOCAL_BASE_PATH = isJoJoUp ? ENV_BASE : '';

export var MINI_PROGRAM_CONFIG_KEY = isJoJoUp ? 'jojoupMiniProgramConfig' : 'miniProgramConfig';
export var MINI_PROGRAM_CONFIG_KEY2 = isJoJoUp ? 'jojoupMiniProgramConfig' : 'addTeacherMiniProgram';
var UC_SWITCH_ENV = envFactory('UC_SWITCH') || 'true'; // CHECK 全局UC开关变量配置

window.uc_switch = !!envDebug || ['true', '1', true].includes(UC_SWITCH_ENV); // 是否调试模式，区别非正式环境

export var DEBUG = !!envName && envName !== 'pro'; // 是否开启本地调试

export var DEBUG_LOCAL = envDebug; // 模拟调试header信息，跳过授权检测

export var DEBUG_HEADER_INFO = envDebug ? {
  // 'X-UAGW-userId': 28163,
  // 'X-UAGW-userId': 31691,
  // 'X-UAGW-userId': 27277,
  // 'X-UAGW-userId': 29924,
  // 'X-UAGW-userId': 29335,
  // 'X-UAGW-userId': 642471,
  // 'X-UAGW-userId': 200529173, // fat 暑期活动
  'X-UAGW-userId': 200621261,
  'X-UAGW-authMode': 1
} : {};
export var MOCK_BASE_URL = 'https://mock.xjjj.co/mock/63a152a8ad75630011128329/mockApi';
export var DEBUG_OPENID = 'oTfKg6u5-CuoitiYoqgbT8NCqSo4';
export var DEBUG_APPID = 'wx6bc1e63a0998b3b7'; // api接口相关

export var CASHBACK_BASE_URL = envFactory('CASHBACK_BASE_URL') || // 'https://mock.xjjj.co/mock/632aa70a57775e001750622e/guoqing' ||
"https://mall-cashback".concat(envPath(envName), ".tinman.cn");
export var CB_BASE_URL = envFactory('CB_BASE_URL') || "https://mall-cashback".concat(envPath(envName), ".tinman.cn");
export var UC_API_DOMAIN = envFactory('UC_API_DOMAIN') || "https://uc-api".concat(envPath(envName), ".tinman.cn");
export var TRACE_BASE_URL = envFactory('TRACE_BASE_URL') || "https://api".concat(envPath(envName), ".jojoread.com");
export var MALL_BASE_URL = envFactory('MALL_BASE_URL') || "https://mall-product".concat(envPath(envName), ".tinman.cn");
export var PAY_BASE_URL = envFactory('PAY_BASE_URL') || "https://mall-pay".concat(envPath(envName), ".tinman.cn");
export var ORDER_PAY_BASE_URL = envFactory('ORDER_PAY_BASE_URL') || "https://api".concat(envPath(envName), ".tinman.cn/api/mall-order-pay");
export var ORDER_BASE_URL = envFactory('ORDER_BASE_URL') || "https://api".concat(envPath(envName), ".tinman.cn/mall/order"); // `https://api${envPath(envName)}.tinman.cn`

export var TINMAN_BASE_C_URL = envFactory('TINMAN_BASE_C_URL') || '';
export var JOJO_READ_URL = envFactory('JOJO_READ_URL') || '';
export var MALL_H5_BASE_URL = envFactory('MALL_H5_BASE_URL') || ''; // 授权失效之后进入链接地址

export var AUTH_SIGN_URL = envFactory('AUTH_SIGN_URL') || 'https://jojoread.tinman.cn/page/wechatMp/portal/entrance'; // 其他

export var AUTH_REDIRECT_PARAMS = 'au_prms'; // query-pay接口，获取到flagCode === 3时，保存跳转链接。一个兜底路径

export var QUERY_PAY_ADD_URL = 'query_pay_add_url';
export var PLACEHOLDER_MAP = 'https://jojopublic.jojoread.com/mall/mall-cashback/activity/image/202104/e701cbe2324347ad8c2affc34cc0bf71.jpg';
export var INDEX_URL = 'idx_url'; // 手机号本地存储保留

export var ORDER_PHONE = 'order_phone';
export var ORDER_AREACODE = 'order_areacode'; // 风控上报taskID

export var TASK_ID = 'report_task_id'; // 记录微信登陆后置的下一步操作

export var WECHAT_AUTH_NEXT = 'wechat_auth_next';
export var MINI_INFO = envName === 'pro' ? {
  userName: 'gh_ef0f0e30ef89',
  miniProgramType: 0,
  miniProgram: 'jojo_read'
} : {
  userName: 'gh_87f2400c676b',
  miniProgramType: 2,
  miniProgram: 'mapp_shusheng_JoJoRead'
};
export var MARKET_MINI_INFO = envName === 'pro' ? {
  userName: 'gh_8a438944f89f',
  miniProgramType: 0,
  miniProgram: 'mapp.shusheng.growingPlan'
} : {
  userName: 'gh_f9eeb4f1101d',
  miniProgramType: '2',
  miniProgram: 'mapp.shusheng.growingAssistant'
};
export var JOJOUP_MINI_INFO = envName === 'pro' ? {
  userName: 'gh_cea7a551d1dc',
  miniProgramType: 0,
  miniProgram: 'mapp.mohezi.jojoupLite'
} : {
  userName: 'gh_283615a01678',
  miniProgramType: 2,
  miniProgram: 'jojo.learning.paradise'
};
export var MINIP_INFO = isJoJoUp ? JOJOUP_MINI_INFO : MINI_INFO; // 用户协议

export var USER_PROTOCOL = envFactory('USER_PROTOCOL') || ''; // 隐私协议

export var PRIVACY_PROTOCOL = envFactory('PRIVACY_PROTOCOL') || ''; // 包名

export var PACKAGE_NAME = isJoJoUp ? 'mp.mohezi.JoJoUp' : 'mp.tinman.JoJoRead'; // 客服地址

export var CUSTOMER_SERVICE_ADDRESS = '/api/pagani/view/jingtan/chat?origin=luodiye'; // 客服中心地址

export var CUSTOMER_SERVICE_CENTER_ADDRESS = envFactory('CUSTOMER_SERVICE_CENTER_ADDRESS') || 'https://jojoread.tinman.cn/read/plan/plan/customerCenter?windowType=normal&deviceOrientation=auto&fullScreen=true&jojoSceneId=2'; // 叫叫领课页地址 mohezi跳转叫叫用 暂时写死为  https://act.tinman.cn JOJO_ACT_PAGE_ORIGIN 未配置，需要时再配置

export var JOJO_ACT_PAGE_ORIGIN = envFactory('JOJO_ACT_PAGE_ORIGIN') || 'https://act.tinman.cn';
export var JOJOUP_ACT_PAGE_ORIGIN = envFactory('JOJOUP_ACT_PAGE_ORIGIN') || 'https://pages.mohezi.cn/mall/landing'; // 客服中间页，该页决定跳什么客服地址

export var CUSTOMER_TRANSFORM = "".concat(isJoJoUp ? window.location.origin : JOJO_ACT_PAGE_ORIGIN).concat(addTeacherPath, "/transform/customerCenter");
var ssl = envFactory('SENSORS_SERVER_URL');
var sensorsMap = {
  fat: 'https://sensors.tinman.cn/sa?project=default',
  uat: 'https://sensors.tinman.cn/sa?project=default',
  dev: 'https://sensors.tinman.cn/sa?project=default',
  pro: isJoJoUp ? 'https://sensors.tinman.cn/sa?project=jojoup' : 'https://sensors.tinman.cn/sa?project=production'
};

if (!ssl) {
  ssl = sensorsMap[envName || ''] || 'https://sensors.tinman.cn/sa?project=production';
} // 新增神策服务器地址


export var sensors_server_url = ssl; // 原生加老师小程序路径

export var NATIVE_MINI_PROGRAM_ADD_TEACHER_PATH = '/pages/pkgs/add_transform/pages/transform/main';
var jojoupOrigin = envName === 'pro' ? "https://pages.mohezi.cn" : "https://pages-".concat(envName, ".mohezi.cn");
var jojoupApiDomain = TINMAN_BASE_C_URL || jojoupOrigin;
export var jojoAccountConfig = isJoJoUp ? {
  envName: envName,
  appName: 'jojoup',
  hosts: {
    ucHost: "".concat(jojoupApiDomain, "/uc/r"),
    serverHost: "".concat(jojoupApiDomain, "/read"),
    apiHost: jojoupApiDomain
  }
} : {
  envName: envName,
  appName: 'jojo'
};
export var APP_ROUTE_INDEX_MAP = {
  1: 'tinman-router://cn.tinman.jojoread/home/square',
  2: 'tinman-router://cn.tinman.jojoread/home/course',
  3: 'tinman-router://cn.tinman.jojoread/home/mine',
  4: 'tinman-router://cn.tinman.jojoread/home/accompany' // 我的

};
export var EXTENDS_DATA = 'extends_data';
export var SENCE_LABEL = 'sence_label';